import {
    CONFIG_CHANGED
  } from './types';
import { debugWarn } from '../util/debug';

/**
 * Get localStorage key for conf persistence
 * Uses hostname to support multiple NVR connections
 */
const getConfStorageKey = () => {
  return `dview_conf_${window.location.hostname}`;
};

/**
 * Save conf to localStorage
 * @param {string} conf - Configuration value (conf-1, conf-4, etc.)
 */
const saveConfToStorage = (conf) => {
  if (!conf || conf === 'conf-fs') return; // Don't save fullscreen
  try {
    localStorage.setItem(getConfStorageKey(), conf);
  } catch (e) {
    debugWarn('[ConfButtonsActions] Failed to save conf to localStorage:', e);
  }
};

/**
 * Default grid layout when the user has no stored preference.
 * Phone-portrait defaults to 2-up (conf-2) — near-16:9 cells with readable names,
 * per the #86bb5dx62 Live redesign (Mock A). Tablet/desktop keep the historical
 * 4-up (conf-4) so this is NOT a desktop regression. This is a one-time initial
 * preference (persisted per-host on first pick), read once at store init — it is
 * NOT a reactive breakpoint, so it does not conflict with the CSS-media-query
 * responsive rule. jsdom reports innerWidth 1024, so tests keep the conf-4 default.
 * @returns {string} 'conf-2' on phone-portrait width, else 'conf-4'
 */
export const getDefaultConf = () => {
  try {
    if (typeof window !== 'undefined' && window.innerWidth && window.innerWidth <= 767) {
      return 'conf-2';
    }
  } catch (e) {
    // window unavailable (SSR/test) — fall through to conf-4
  }
  return 'conf-4';
};

/**
 * Load conf from localStorage
 * @returns {string|null} - Saved conf or null
 */
export const loadConfFromStorage = () => {
  try {
    const saved = localStorage.getItem(getConfStorageKey());
    if (saved && saved.startsWith('conf-')) {
      return saved;
    }
  } catch (e) {
    debugWarn('[ConfButtonsActions] Failed to load conf from localStorage:', e);
  }
  return null;
};

/**
 * Change the grid configuration and persist to localStorage
 */
export const configChange = conf => {
  // Save to localStorage for persistence across refreshes/logouts
  saveConfToStorage(conf);

  return {
    type: CONFIG_CHANGED,
    payload: conf
  };
};
